<template lang="html">
  <div class="transactions-wrapper">
    {{ productInfo.getTransactions }}
    <table>
      <thead>
        <tr>
          <td>{{ $t("details.transactions.date") }}</td>
          <td>{{ $t("details.transactions.buyer") }}</td>
          <td class="center" v-for="price in prices" :key="price.prc_id">
            {{
              price.min
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            -
            {{
              price.max
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            <span class="lowercase">{{ showUnit(productInfo.mun_unit) }}</span
            ><br />
            {{
              price.prc_price
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ currency }}
          </td>
          <!-- <td>{{$t('details.transactions.other')}}</td> -->
          <td>{{ $t("details.transactions.condition") }}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in tableData" :key="index">
          <td>{{ user.off_date ? user.off_date : "/" }}</td>
          <td>{{ user.usr_name ? user.usr_name : "/" }}</td>
          <td class="center" v-for="price in prices" :key="price.prc_id">
            {{
              user.prc_id === price.prc_id
                ? user.off_quantity
                    .toLocaleString("en")
                    .split(",")
                    .join(".")
                : "-"
            }}
          </td>
          <!-- <td>{{user.other ? user.other : '/'}}</td> -->
          <td>
            {{
              user.off_type !== undefined ? getTranslation(user.off_type) : "-"
            }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="info">
      <span class="info-key">{{ $t("details.transactions.quantity") }}:</span>
      <span class="info-value">{{
        quantity
          .toLocaleString("en")
          .split(",")
          .join(".")
      }}</span>
    </div>
    <div class="info">
      <span class="info-key"
        >{{ $t("details.transactions.currentPrice") }}:</span
      >
      <span class="info-value"
        >{{
          currentPrice
            .toLocaleString("en")
            .split(",")
            .join(".")
        }}
        {{ currency }}</span
      >
    </div>
    <div v-if="tableData.length === 0" class="no-transaction">
      {{ $t("main.noTransactions") }}
    </div>
    <div
      class="small-transactions"
      v-for="(user, index) in tableData"
      :key="index"
    >
      <div class="top">
        <div class="info">
          <div class="key">
            {{ $t("details.transactions.buyer") }}
          </div>
          <div class="value">
            {{ user.usr_name ? user.usr_name : "-" }}
          </div>
        </div>
        <div class="info">
          <div class="key">
            {{ $t("details.transactions.date") }}
          </div>
          <div class="value">
            {{ user.off_date ? user.off_date : "-" }}
          </div>
        </div>
      </div>
      <div class="bottom">
        <div v-for="price in prices" :key="price.prc_id" class="info">
          <div class="key">
            {{
              price.min
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            -
            {{
              price.max
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            <span class="lowercase">{{ showUnit(productInfo.mun_unit) }}</span>
            {{
              price.prc_price
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ currency }}
          </div>
          <div class="value">
            {{
              user.prc_id === price.prc_id
                ? user.off_quantity
                    .toLocaleString("en")
                    .split(",")
                    .join(".")
                : "-"
            }}
          </div>
        </div>
        <div class="info">
          <div class="key">
            {{ $t("details.transactions.condition") }}
          </div>
          <div class="value">
            {{
              user.off_type !== undefined ? getTranslation(user.off_type) : "-"
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
export default {
  name: "itemTransactions",
  props: {
    productInfo: {
      type: Object
    }
  },
  data() {
    return {
      tableData: [],
      prices: [],
      quantity: "",
      currentPrice: "",
      currency: ""
    };
  },
  mounted() {
    this.getTransactions();
  },
  watch: {
    $route: {
      handler() {
        this.getTransactions();
      },
      deep: true
    }
  },
  methods: {
    getTransactions() {
      let params = {
        pro_id: this.$route.params.id
      };
      api
        .getProductTransactions(params)
        .then(res => {
          this.tableData = res.data.data;
          this.prices = res.data.meta.prices;
          this.quantity = res.data.meta.off_count;
          this.currentPrice = res.data.meta.current_price;
          this.currency = res.data.meta.cur_id;
        })
        .catch(e => {
          console.log(e);
        });
    },
    showUnit(munUnit) {
      if (munUnit === "komad" || munUnit === "komada") {
        return this.$t("item.items");
      } else if (munUnit === "paket" || munUnit === "paketa") {
        return this.$t("item.package");
      }
      return munUnit;
    }
  },
  computed: {
    getTranslation() {
      return condition => {
        if (condition === 1) {
          return this.$t("dropdown.condition1");
        } else {
          return this.$t("dropdown.condition2");
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.transactions-wrapper {
  margin-top: 20px;
  margin-right: 20px;
  padding-right: 20px !important;
  max-width: 100vw !important;
  overflow: auto !important;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;

  .small-transactions {
    display: none;
    border: 1px solid $gray-blue-700;
    box-sizing: border-box;
    border-radius: 12px;
    margin-bottom: 12px;

    .top {
      background: $gray-blue-400;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      padding: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .info {
        display: flex;
        flex-direction: column;
        text-align: left;
        margin: 0px;

        font-weight: 400;
        font-style: Medium;
        font-size: 18px;
        line-height: 130%;
        letter-spacing: 0%;

        .key {
          color: $blue-400;

          margin-right: 5px;
          text-transform: lowercase !important;
        }
        .key::first-letter {
          text-transform: uppercase;
        }
        .value {
          color: $blue-1000;
        }
      }
    }
    .bottom {
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .info {
        display: flex;
        flex-direction: column;
        text-align: left;

        font-weight: 400;
        font-style: Medium;
        font-size: 16px;
        line-height: 130%;
        letter-spacing: 0%;

        .key {
          color: $blue-400;
          width: 100%;
          text-align: left;
        }
        .value {
          color: $blue-1000;
        }
      }
    }
  }

  .info {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    margin: 10px auto;

    text-align: left;

    font-weight: 400;
    font-style: Regular;
    font-size: 18px;
    line-height: 130%;
    letter-spacing: 0%;

    .info-key {
      color: $gray-blue-1300;
      margin-right: 15px;
      white-space: nowrap;
      min-width: 160px;
    }
    .info-value {
      color: $blue-1000;
    }
  }
  .no-transaction {
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;

    color: $gray-blue-1300;
    padding-bottom: 40px;
  }
  .no-transaction::first-letter {
    text-transform: uppercase;
  }
  // @import "@/assets/scss/tableStyles.scss";
  table {
    margin-bottom: 20px;
    max-width: 100vw !important;
    overflow: auto !important;
    border-collapse: collapse;

    @import "@/assets/scss/scrollbarStyles.scss";
    @include scrollbar;
    thead td span.lowercase {
      text-transform: lowercase;
    }
    thead td {
      white-space: nowrap;

      // border-bottom: 1px solid $gray-blue-700;
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;

      line-height: 130%;
      letter-spacing: 0%;
      color: $blue-400;
    }
    td {
      border-bottom: 1px solid $gray-blue-700;
      padding: 20px;
      text-align: left;

      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: 0%;
      color: $blue-1000;
    }
    // td.center {
    //   text-align: center;
    // }
  }
}
@media only screen and (max-width: 1000px) {
  table {
    display: none;
  }
  .transactions-wrapper {
    margin: 0;
    margin-bottom: 20px;
    padding-right: 0px !important;

    .info {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      width: 100%;
      margin: 10px auto;

      text-align: left;

      font-size: 16px;

      .info-key {
        color: $gray-blue-1300;
        margin-right: 15px;
        white-space: nowrap;
        min-width: fit-content;
      }
      .info-value {
        color: $blue-1000;
      }
    }
  }
  .small-transactions {
    display: block !important;
  }
}
</style>
